import { useTranslations } from '@vocab/react';
import {
  Actions,
  Box,
  Heading,
  Hidden,
  Stack,
  Text,
} from 'braid-design-system';

import { ButtonLink } from 'src/components/Link/Link';
import { links } from 'src/links';
import {
  seekBlueLight700,
  seekBlueLight800,
  seekDeepMagenta700,
} from 'src/theme';

import translations from '../.vocab';

import * as styles from './Banners.css';

export const HeaderBanner = () => {
  const { t } = useTranslations(translations);

  return (
    <Box
      marginY={['medium', 'medium', 'medium']}
      position="relative"
      style={{ background: seekBlueLight800 }}
      background="customDark"
      borderRadius="large"
      paddingY={['large', 'large', 'xxlarge']}
      paddingX={['large', 'large', 'xxlarge']}
      overflow="hidden"
    >
      <Box paddingX="xxlarge">
        <Stack space="medium" align={['center', 'center', 'left']}>
          <Heading level="3" align={['center', 'center', 'left']} weight="weak">
            {t('ourConnectedPartners')}
          </Heading>
          <Text
            size="standard"
            align={['center', 'center', 'left']}
            weight="regular"
            tone="neutral"
          >
            {t('yourATSConnectedPartner')}
          </Text>
          <Actions>
            {
              <>
                <ButtonLink
                  variant="solid"
                  tone="brandAccent"
                  href={links.LINK_YOUR_SOFTWARE.path}
                  tracking={links.LINK_YOUR_SOFTWARE.tracking}
                >
                  {t('linkYourATS')}
                </ButtonLink>
              </>
            }
          </Actions>
        </Stack>
      </Box>

      <Hidden below="desktop">
        <svg
          width="101"
          height="103"
          viewBox="0 0 101 103"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          className={styles.almostMiddleLeftShape}
        >
          <path
            d="M0.000470583 -4.48669e-06L0.000467581 34.3333C9.44855 34.3333 17.1077 42.0191 17.1077 51.5C17.1077 60.9809 9.44854 68.6667 0.00046458 68.6667L0.000461578 103C28.3447 103 51.3223 79.9427 51.3223 51.5C51.3223 23.0573 28.3447 -2.00876e-06 0.000470583 -4.48669e-06Z"
            fill={seekBlueLight700}
          />
          <path
            d="M49.5005 -4.48669e-06L49.5005 34.3333C58.9485 34.3333 66.6077 42.0191 66.6077 51.5C66.6077 60.9809 58.9485 68.6667 49.5005 68.6667L49.5005 103C77.8447 103 100.822 79.9427 100.822 51.5C100.822 23.0573 77.8447 -2.00876e-06 49.5005 -4.48669e-06Z"
            fill={seekBlueLight700}
          />
        </svg>

        <svg
          width="106"
          height="106"
          viewBox="0 0 106 106"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          className={styles.topRightShape}
        >
          <circle cx="106" r="106" fill={seekDeepMagenta700} />
        </svg>

        <svg
          width="250"
          height="102"
          viewBox="0 0 250 102"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          className={styles.bottomRightMiddleShape}
        >
          <path
            d="M125 72.5807C96.0496 72.5807 72.5807 96.0496 72.5807 125C72.5807 153.95 96.0496 177.419 125 177.419C153.95 177.419 177.419 153.95 177.419 125C177.419 96.0496 153.95 72.5807 125 72.5807ZM0 125C0 55.9644 55.9644 0 125 0C194.036 0 250 55.9644 250 125C250 194.036 194.036 250 125 250C55.9644 250 0 194.036 0 125Z"
            fill={seekBlueLight700}
          />
        </svg>
      </Hidden>
    </Box>
  );
};
